export default __webpack_public_path__ + "static/media/ColorShiftsMaster.df0a00e4.svg";